/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_download': {
    width: 14,
    height: 17,
    viewBox: '0 0 14 17',
    data: '<defs><path pid="0" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" id="svgicon_icon_download_a"/></defs><g transform="translate(-5 -3)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_download_b" _fill="#fff"><use xlink:href="#svgicon_icon_download_a"/></mask><g mask="url(#svgicon_icon_download_b)" _fill="#898D94"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_download.js